export default {"src":"/_next/static/media/apple.456fe1f4.svg","height":47,"width":38,"blurWidth":0,"blurHeight":0};